import { NavigationLink } from '../app/shared/interfaces/navigation-link';

export const departments: NavigationLink[] = [
    {label: 'Womens Fashion', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},

    {label: 'Mens Fashion', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Fashion Accessories', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Shoes & Bags', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Sports & Outdoor', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Home & Lifestyle', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Electronic', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'TV & Home Appliance', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Babies & Toys', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},
    {label: 'Health & Beauty', url: './shop', menu: {
        type: 'megamenu',
        size: 'xl',
        image: 'assets/images/megamenu/megamenu-1.jpg',
        columns: [
            {size: 3, items: [
                {label: 'New Arrival', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
                {label: 'T-Shirt', url: './shop', items: [
                    {label: 'Engravers', url: './shop'},
                    {label: 'Drills', url: './shop'},
                    {label: 'Wrenches', url: './shop'},
                    {label: 'Plumbing', url: './shop'},
                    {label: 'Wall Chaser', url: './shop'},
                    {label: 'Pneumatic Tools', url: './shop'},
                    {label: 'Milling Cutters', url: './shop'}
                ]},
            ]},
            {size: 3, items: [
                {label: 'Shirt', url: './shop', items: [
                    {label: 'Screwdrivers', url: './shop'},
                    {label: 'Handsaws', url: './shop'},
                    {label: 'Knives', url: './shop'},
                    {label: 'Axes', url: './shop'},
                    {label: 'Multitools', url: './shop'},
                    {label: 'Paint Tools', url: './shop'}
                ]},
                {label: 'Jacket/Coat', url: './shop', items: [
                    {label: 'Motor Pumps', url: './shop'},
                    {label: 'Chainsaws', url: './shop'},
                    {label: 'Electric Saws', url: './shop'},
                    {label: 'Brush Cutters', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Dress', url: './shop', items: [
                    {label: 'Thread Cutting', url: './shop'},
                    {label: 'Chip Blowers', url: './shop'},
                    {label: 'Sharpening Machines', url: './shop'},
                    {label: 'Pipe Cutters', url: './shop'},
                    {label: 'Slotting machines', url: './shop'},
                    {label: 'Lathes', url: './shop'}
                ]}
            ]},
            {size: 3, items: [
                {label: 'Casual Pants', url: './shop', items: [
                    {label: 'Welding Equipment', url: './shop'},
                    {label: 'Power Tools', url: './shop'},
                    {label: 'Hand Tools', url: './shop'},
                    {label: 'Measuring Tool', url: './shop'}
                ]}
            ]}
        ]
    }},



    {label: 'Weni Special',        url: './shop'},

];
